// extracted by mini-css-extract-plugin
export default {"body-fixed":"LoginPage_body-fixed__BO-Bn","center-container":"LoginPage_center-container__f-F2V","code-input-container":"LoginPage_code-input-container__HfXkl"};